<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<div class="box10">
<p class="center"><img alt="" src="OEBPS/images/9780312876531_tp01.png"/></p>
<p class="center"><span class="big">THE</span><br/><br/><span class="big10">KING’S</span><br/><br/><span class="big10">NAME</span><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/9780312876531_tp02.png"/><br/><br/></p>
<p class="center"><span class="big1">JO WALTON</span><br/><br/></p>
</div>
<p class="center"><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/9780312876531_tp03.png"/><br/><span class="small">A TOM DOHERTY ASSOCIATES BOOK</span><br/><span class="small">NEW YORK</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312876531_epub_tp_r1.vue?6153919e